export default {
  sectionNavLinksV2: {
    container: {
      backgroundColor: 'backgroundSecondary',
      '.lazyload-wrapper': {
        width: ['100%', '100%', 'calc(50% - 3rem)', 'calc(50% - 3rem)'],
        margin: 5,
        flexGrow: '1'
      }
    },
    boxes: {
      maxWidth: '1200px',
      margin: '0 auto',
      flexWrap: 'wrap',
      justifyContent: 'center',
      width: '100%',
      display: 'flex'
    },
    box: {
      // width: ['100%', '100%', 'calc(50% - 3rem)', 'calc(50% - 3rem)'],
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'stretch',
      backgroundPosition: 'center',
      transition: 'all ease-in-out 2s',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      '&:hover': {
        backgroundPosition: 'bottom left'
      },
      a: {
        width: '100%',
        padding: '1rem 2rem',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover > *': {
          backgroundColor: 'primary'
        }
      }
    },
    linkName: {
      width: '100%',
      color: 'light',
      backgroundColor: 'secondary',
      padding: 4,
      fontSize: 4,
      maxWidth: '250px',
      margin: '0 auto',
      textTransform: 'uppercase',
      transition: 'all ease-in-out 0.5s',
      textAlign: 'center'
    }
  }
}
